
import { Progress } from '../../ui/progress';


interface QuizHeaderProps {
  currentQuestionIndex: number;
  totalQuestions: number;
}

const QuizHeader = ({ currentQuestionIndex, totalQuestions }: QuizHeaderProps) => {
  const progress = (currentQuestionIndex / totalQuestions) * 100;

  return (
    <>
      {/* Airdrop Eligibility Banner */}
      <div className="mb-6 p-4 bg-tan text-navy-dark rounded-lg">
        <div className="flex items-center space-x-2 mb-2">
          <img 
            src="/lovable-uploads/clr_4.png" 
            alt="Bromentum Logo" 
            className="w-6 h-6 object-contain"
          />
          <span className="font-bold">🎁 Airdrop Eligibility</span>
        </div>
        <p className="text-sm">Complete the cipher to earn your BroCode and become eligible for future airdrops!</p>
      </div>

      <div className="mb-8">
        <h2 className="text-2xl font-patrick mb-2">Cipher Question {currentQuestionIndex + 1}/{totalQuestions}</h2>
        <Progress value={progress} className="h-2 bg-navy-dark">
          <div 
            className="h-full bg-tan rounded-full transition-all duration-300" 
          ></div>
        </Progress>
      </div>
    </>
  );
};

export default QuizHeader;
